const sectors = [
  {
    label: "TECHNOLOGY",
    desc: "Software, SaaS, cybersecurity, and digital infrastructure across the UK and international markets.",
    image: "https://public.readdy.ai/ai/img_res/367c0dca82f93a6f977b9624a1675c65.jpg",
  },
  {
    label: "MANUFACTURING",
    desc: "Precision engineering, industrial consolidation, and advanced manufacturing across key sectors.",
    image: "https://readdy.ai/api/search-image?query=industrial%20manufacturing%20facility%20dark%20dramatic%20lighting%20precision%20engineering%20machinery%20abstract%20minimal%20elegant%20black%20metallic%20premium&width=800&height=600&seq=port003&orientation=landscape",
  },
  {
    label: "ENERGY",
    desc: "Renewable infrastructure, energy transition assets, and resource-backed opportunities.",
    image: "https://readdy.ai/api/search-image?query=wind%20turbines%20at%20sunset%20dark%20dramatic%20sky%20industrial%20energy%20infrastructure%20aerial%20view%20minimal%20elegant%20black%20and%20gold%20tones%20premium&width=800&height=600&seq=port002&orientation=landscape",
  },
  {
    label: "PHARMACEUTICALS",
    desc: "Life sciences, clinical-stage assets, and healthcare businesses with strong growth fundamentals.",
    image: "https://readdy.ai/api/search-image?query=pharmaceutical%20laboratory%20dark%20elegant%20minimal%20scientific%20research%20abstract%20blue%20light%20microscope%20premium%20luxury%20corporate&width=800&height=600&seq=port004&orientation=landscape",
  },
  {
    label: "REAL ASSETS",
    desc: "Infrastructure, logistics, and real asset acquisitions with long-term value creation potential.",
    image: "https://readdy.ai/api/search-image?query=infrastructure%20bridge%20highway%20aerial%20view%20dark%20dramatic%20sky%20minimal%20elegant%20black%20and%20gold%20tones%20premium%20luxury%20finance&width=800&height=600&seq=port006&orientation=landscape",
  },
  {
    label: "FINANCIAL SERVICES",
    desc: "Specialty finance, asset management platforms, and financial infrastructure across global markets.",
    image: "https://readdy.ai/api/search-image?query=financial%20district%20city%20skyline%20dark%20night%20dramatic%20luxury%20corporate%20skyscrapers%20abstract%20minimal%20elegant%20black%20gold%20premium&width=800&height=600&seq=port007&orientation=landscape",
  },
];

export default function PortfolioSection() {
  return (
    <section id="portfolio" className="w-full bg-[#0d0d0d] py-20 sm:py-28 px-5 sm:px-8 md:px-16">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#c9a84c] text-[10px] tracking-[5px] uppercase mb-4 sm:mb-5">Strategic Sectors</p>
          <h2 className="text-white font-serif text-2xl sm:text-3xl md:text-5xl tracking-wide mb-4 sm:mb-6">
            Target Sectors
          </h2>
          <p className="text-white/40 text-sm max-w-xs sm:max-w-xl mx-auto leading-relaxed">
            Focused on scalable, resilient businesses with strong underlying fundamentals.
          </p>
        </div>

        {/* Sector grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {sectors.map((sector) => (
            <div
              key={sector.label}
              className="group relative overflow-hidden bg-[#0d0d0d] cursor-default h-[240px] sm:h-[280px] lg:h-[320px]"
            >
              <img
                src={sector.image}
                alt={sector.label}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/10" />

              {/* Overlay content */}
              <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-7">
                <p className="text-[#c9a84c] text-[10px] tracking-[3px] sm:tracking-[4px] uppercase mb-2">{sector.label}</p>
                <p className="text-white/55 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-400 max-h-0 group-hover:max-h-20 overflow-hidden">
                  {sector.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-16 px-4 sm:px-0">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-block w-full sm:w-auto px-10 sm:px-14 py-4 border border-[#c9a84c] text-[#c9a84c] text-xs tracking-[3px] sm:tracking-[4px] uppercase hover:bg-[#c9a84c] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
          >
            DISCUSS YOUR MANDATE
          </a>
        </div>
      </div>
    </section>
  );
}
